export default class Counter {
    /**
     * @type {HTMLElement}
     */
    domElement;

    /**
     * @type {HTMLElement}
     */
    incButton;

    /**
     * @type {HTMLElement}
     */
    decButton;

    /**
     * @type {HTMLInputElement}
     */
    input;

    max = 99;
    min = 1;

    _value;

    /**
     * @type {Map<string, []>}
     */
    listeners = new Map();

    get value() {
        return this._value;
    }

    set value(value) {
        if (Number(value) === this._value) {
            return;
        }
        this._value = this.validateValue(value);
        this.handleButtons();

        if (this.listeners.has('change')) {
            const callbacks = this.listeners.get('change');
            Object.values(callbacks).forEach(callback => {
                callback(this.value);
            });
        }
    }

    constructor(domElement) {
        this.domElement = domElement;

        if(!this.domElement) {
            return;
        }
        
        this.input = this.domElement.querySelector('.counter__input');
        this.incButton = this.domElement.querySelector('.counter__control--increment');
        this.decButton = this.domElement.querySelector('.counter__control--decrement');

        if (!this.input) {
            return;
        }
        this.domElement.counter = this;
        this.value = this.input.value;

        this.addListeners();
    }

    addListeners() {
        this.input.addEventListener('change', () => {
            this.value = this.input.value;
        });

        if (this.incButton) {
            this.incButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.value += 1;
            });
        }
        
        if (this.decButton) {
            this.decButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.value -= 1;
            });
        }
    }

    updateValueInInput(val) {
        this.input.value = val;
    }

    validateValue(value) {
        let numValue = Number(value);

        if (numValue <= this.min) {
            numValue = this.min;
        }

        if (numValue >= this.max) {
            numValue = this.max;
        }

        this.updateValueInInput(numValue);
        return numValue;
    }

    handleButtons() {
        if (this.value <= this.min) {
            this.decButton.setAttribute('disabled', true);
        } else {
            this.decButton.removeAttribute('disabled');
        }

        if (this.value >= this.max) {
            this.incButton.setAttribute('disabled', true);
        } else {
            this.incButton.removeAttribute('disabled');
        }
    }
    on(eventName, handler) {
        if (!this.domElement) {
            return;
        }

        this.listeners.has(eventName) || this.listeners.set(eventName, []);
        this.listeners.get(eventName).push(handler);
    }
}
